/* work-type-example.js — 사장 R-10 예시 화면의 동작: 가입 뒤 「우리 회사는 어떻게 일하나요?」(S3) 고르기.
 * (가입 3단계 [예시 보기] 덮개는 R-789 한 화면 가입으로 3단계가 없어져 뺐다.)
 *
 * ★저장은 기존 근무정책 API 그대로★ — provision(keep_selections: 선택·열린 초안이 있으면 안 덮는다),
 * 매장형이고 ★새로 만든 초안일 때만★ 가입처럼 바로 게시한다(남이 고치던 초안을 게시하지 않는다).
 * 🚫 여기에 새 저장 창구를 만들지 마라 — 가입 뒤 회사는 자기 창고 DB 로 옮겨져 있고, 창고 라우팅은 admin API 가 맞춘다.
 * 근무 방식 값(roster·fixed)은 화면이 `data-mode` 로 준다(정본 `company-work-type.COMPANY_WORK_TYPE_DEFAULT_MODE`).
 */
(function () {
  if (window.__insWtxWire) return;
  window.__insWtxWire = true;

  var BASE = '/api/admin/enterprise/attendance-policies';

  function key(prefix) {
    var rnd = '';
    try { rnd = (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2)); } catch (_) { rnd = String(Date.now()); }
    return (prefix + '-' + rnd).replace(/[^A-Za-z0-9_-]/g, '').slice(0, 100);
  }

  function send(method, url, body, idem) {
    var headers = { accept: 'application/json' };
    if (body) headers['content-type'] = 'application/json';
    if (idem) headers['Idempotency-Key'] = idem;
    return fetch(url, { method: method, headers: headers, credentials: 'same-origin', body: body ? JSON.stringify(body) : undefined })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) { return { status: res.status, data: data }; });
      });
  }

  function fail(root, buttons) {
    var err = root.querySelector('[data-wtx-choice-error]');
    if (err) { err.textContent = '저장하지 못했어요. 잠시 뒤 다시 눌러 주세요.'; err.hidden = false; }
    buttons.forEach(function (b) { b.disabled = false; });
  }

  function choose(btn) {
    var root = btn.closest('[data-work-type-choice]');
    if (!root) return;
    var type = btn.getAttribute('data-type');
    var mode = btn.getAttribute('data-mode');
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-act="wtx-choose"]'));
    buttons.forEach(function (b) { b.disabled = true; });
    var err = root.querySelector('[data-wtx-choice-error]');
    if (err) err.hidden = true;

    send('POST', BASE + '/provision', { selected_modes: [mode], primary_mode: mode, keep_selections: true }, key('wtx-provision'))
      .then(function (r) {
        if (!r.data || r.data.success !== true) throw new Error('provision');
        var policyId = r.data.data && r.data.data.policy_id;
        /* 가입과 같다 — 매장형은 새 초안을 바로 게시해야 근무표 저장이 열린다. created=false 면 남의 초안이라 손대지 않는다. */
        if (mode !== 'roster' || r.status !== 201 || !policyId) return null;
        return send('GET', BASE + '/drafts/' + policyId, null, null).then(function (d) {
          var ver = d.data && d.data.data && d.data.data.edit_version;
          if (!ver) return null;
          return send('POST', BASE + '/drafts/' + policyId + '/publish', { edit_version: ver }, key('wtx-publish'));
        });
      })
      .then(function () {
        location.replace(root.getAttribute('data-next') + '&type=' + encodeURIComponent(type));
      })
      .catch(function () { fail(root, buttons); });
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest ? ev.target.closest('[data-act="wtx-choose"]') : null;
    if (btn && !btn.disabled) choose(btn);
  });
})();
